import { makeStyles } from "@material-ui/core/styles";
import { EFlagPriority, flagLevels } from "components/VetExamsTable/helper";

export default makeStyles(() => {
  const { lowest, medium, highest } = flagLevels;

  return {
    activeFlaggedIcon: {
      marginLeft: 4,
      fontSize: 14,
      position: "relative"
    },
    [EFlagPriority.LOWEST]: {
      color: lowest
    },
    [EFlagPriority.MEDIUM]: {
      color: medium
    },
    [EFlagPriority.HIGHEST]: {
      color: highest
    }
  };
});
